import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import React, { useState } from "react";

import { translation } from "@/i18n";
import { nsAccountMenu } from "@/i18n/locales/accountMenu";
import { useDialogStyles } from "@/styles";

const useTranslation = translation.use(nsAccountMenu);

export const SignOutConfirmDialog: React.FC<{
  open: boolean;
  onClose: () => void;
}> = ({ open, onClose }) => {
  const { t } = useTranslation();
  const dialogClasses = useDialogStyles();
  const [isSignOutInProgress, setIsSignOutInProgress] = useState(false);

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogSurface className={dialogClasses.dialog}>
        <DialogBody>
          <DialogTitle>{t.accountMenu.signOutDialog.title()}</DialogTitle>
          <DialogContent>{t.accountMenu.signOutDialog.message()}</DialogContent>
          <DialogActions>
            <Button
              appearance="primary"
              onClick={() => {
                setIsSignOutInProgress(true);
                // @ts-ignore
                window.signOut();
              }}
              disabled={isSignOutInProgress}
            >
              {t.accountMenu.signOutDialog.confirmButton()}
            </Button>
            <Button onClick={onClose} disabled={isSignOutInProgress}>
              {t.accountMenu.signOutDialog.cancelButton()}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
